import "./es.array.concat-d1c9b847.js";
import { useState as y, useRef as d, useCallback as C, useLayoutEffect as g, useEffect as f } from "react";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import { useResizeObserver as k } from "./useResizeObserver.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./export-cdcbfb2b.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./isApiSupported-66660265.js";
import "./isClient-2f5bedbd.js";
import "./useIsMounted.js";
import "./useEventListener.js";
import "./useOverFlown.js";
var vt = function(v, t, r) {
  r === void 0 && (r = []);
  var e = y({
    isContained: !1,
    isContainedX: !1,
    isContainedY: !1
  }), m = e[0], p = e[1], i = k(v), o = d(null), l = C(function() {
    t.current && (o.current = t.current.getBoundingClientRect());
  }, [t].concat(r)), n = C(function() {
    if (!(!(i != null && i.contentRect) || !o.current)) {
      var a = i.contentRect, u = o.current, c = u.width <= a.width, s = u.height <= a.height, h = c && s;
      p({
        isContainedX: c,
        isContainedY: s,
        isContained: h
      });
    }
  }, [i]);
  return g(function() {
    p({
      isContained: !0,
      isContainedX: !0,
      isContainedY: !0
    });
  }, r), f(function() {
    t.current && (t.current.style.opacity = "0"), l(), n(), t.current && (t.current.style.opacity = "1");
  }, [].concat(r, [m.isContained])), f(n, [n]), m;
};
export {
  vt as useContainmentCheck
};
